import { Component, ChangeDetectionStrategy, signal, HostListener, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { MatSidenavModule } from '@angular/material/sidenav';
import { GlobalHeaderComponent } from '../../../../shared/components/layout/global-header/global-header';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { GlobalFooterComponent } from '../../../../shared/components/layout/global-footer/global-footer';
import { GlobalSidebarComponent } from '../../../../shared/components/layout/global-sidebar/global-sidebar';
import { SidebarItem } from '../../../../shared/components/layout/global-sidebar/sidebar.model';
import { routeChainHidesSidebar } from '../../../../shared/components/layout/global-sidebar/sidebar-utils';
import { BreadcrumbService } from '../../../../core/services/breadcrumb.service';

@Component({
  selector: 'app-budget-layout',
  standalone: true,
  imports: [
    GlobalHeaderComponent,
    GlobalFooterComponent,
    GlobalSidebarComponent,
    BreadcrumbComponent,
    RouterOutlet,
    MatSidenavModule,
    TranslatePipe
  ],

  templateUrl: './budget-layout.component.html',
  styleUrls: ['./budget-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetLayoutComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  hideSidebar = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => routeChainHidesSidebar(this.activatedRoute.snapshot)),
      startWith(routeChainHidesSidebar(this.activatedRoute.snapshot)),
    ),
    { requireSync: true },
  );

  protected breadcrumbService = inject(BreadcrumbService);
  isMobile = signal(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  @HostListener('window:resize')
  onResize() {
    if (typeof window !== 'undefined') {
      this.isMobile.set(window.innerWidth <= 768);
      if (this.isMobile()) this.sidenavOpened.set(false);
      else this.sidenavOpened.set(true);
    }
  }
  sidenavOpened = signal(typeof window !== 'undefined' ? window.innerWidth > 768 : true);

  menuConfig: SidebarItem[] = [
    { id: 'item_0', label: 'budget.sidebar.dashboard', icon: 'dashboard', route: '/budget', exact: true, permission: 'budget:dashboard' },
    { id: 'item_5', label: 'budget.sidebar.budgetAppropriation', icon: 'assignment_turned_in', route: '/budget/budget-appropriation', permission: 'budget:budget-appropriation' },

    {
      id: 'allocation_group',
      label: 'budget.sidebar.allocationGroup',
      icon: 'assignment_turned_in',
      children: [

        { id: 'item_6', label: 'budget.sidebar.budgetAllocation', /*icon: 'assignment_turned_in',*/ route: '/budget/budget-allocation', permission: 'budget:budget-allocation' },
        { id: 'item_8_voucher', label: 'budget.sidebar.voucher', /* icon: 'receipt',*/ route: '/budget/voucher', permission: 'budget:voucher' },
        { id: 'item_transfer', label: 'budget.sidebar.budgetTransfer', route: '/budget/budget-transfer', permission: 'budget:budget-transfer' }

      ]
    },

    {
      id: 'return_group',
      label: 'budget.sidebar.returnGroup',
      icon: 'assignment_return',
      children: [

        { id: 'item_return_create', label: 'budget.sidebar.createReturn', route: '/budget/budget-return', permission: 'budget:budget-return' },
        { id: 'item_return_voucher', label: 'budget.sidebar.returnVoucher', route: '/budget/budget-return/return-voucher', permission: 'budget:return-voucher' }

      ]
    },

    {
      id: 'report_group',
      label: 'budget.sidebar.reportGroup',
      icon: 'summarize',
      children: [

        { id: 'item_6_db', label: 'budget.allocation.divisionDetail.title',/* icon: 'account_balance_wallet',*/ route: '/budget/division-budget', permission: 'budget:division-budget' },
        { id: 'item_9_bhr', label: 'budget.sidebar.budgetHeadReport',/* icon: 'summarize', */route: '/budget/budget-head-report', permission: 'budget:budget-head-report' }

      ]
    },

    { id: 'item_4', label: 'budget.sidebar.chartOfAccount', icon: 'format_list_bulleted', route: '/budget/chart-of-account', permission: 'budget:chart-of-account' },

    {
      id: 'master_setup',
      label: 'budget.sidebar.masterSetup',
      icon: 'show_chart',
      children: [

        { id: 'item_2', label: 'budget.sidebar.finYear', /* icon: 'date_range',*/ route: '/budget/fin-year', permission: 'budget:fin-year' },
        { id: 'item_3', label: 'budget.sidebar.budgetHierarchy', /*icon: 'account_tree',*/ route: '/budget/budget-hierarchy', permission: 'budget:budget-hierarchy' },
        { id: 'item_6_nbh', label: 'budget.nodeBudgetHead.title', /*icon: 'compare_arrows',*/ route: '/budget/node-budget-head', permission: 'budget:node-budget-head' },
        { id: 'item_7', label: 'budget.sidebar.accountMapping',/* icon: 'account_balance',*/ route: '/budget/account-mapping', permission: 'budget:account-mapping' }

      ]
    },

  ];




  toggleSidenav(): void {
    this.sidenavOpened.update(v => !v);
  }
}
